<!-- HEALTH SHERPA-->
<div class='quick-link'>
  <a href="javascript:void(0)" (click)="$event.preventDefault(); submitSSOForm();" class="external-link">
    {{ healthSherpaLabel || 'AgentCubed' }}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</div>
